<template>
  <div
    class="hotspot-container"
    @click="onClick">
    <HotspotPulse v-if="hotspot && hotspot._slug !== 'block'" class="pulse" :small="false"/>

    <div class="circle-outline absolute-center">
      <div class="dot absolute-center"></div>
      <IconExit v-if="isIcon('exit')" class="absolute-center svg-fill-black"></IconExit>
      <IconClose v-else-if="isIcon('close')" class="absolute-center svg-stroke-black"></IconClose>
      <IconOpen v-else-if="isIcon('open')" class="absolute-center svg-stroke-black"></IconOpen>
      <IconArrowRight  v-else-if="isIcon('right')" class="absolute-center svg-fill-white"></IconArrowRight>
      <IconArrowLeft v-else-if="isIcon('left')" class="absolute-center svg-fill-white"></IconArrowLeft>
      <IconArrowDown v-else-if="isIcon('down')" class="absolute-center svg-fill-white"></IconArrowDown>
      <IconArrowUp v-else-if="isIcon('up')" class="absolute-center svg-fill-white"></IconArrowUp>
      <IconPov v-else class="absolute-center svg-fill-white"></IconPov>
    </div>
  </div>
</template>

<script>
import HotspotPulse from './HotspotPulse.vue'

import IconExit from '@/assets/svg/exit.svg'
import IconClose from '@/assets/svg/close-door.svg'
import IconOpen from '@/assets/svg/open.svg'
import IconPov from '@/assets/svg/pov.svg'
import IconArrowLeft from '@/assets/svg/arrow-left.svg'
import IconArrowRight from '@/assets/svg/arrow-right.svg'
import IconArrowUp from '@/assets/svg/arrow-up.svg'
import IconArrowDown from '@/assets/svg/arrow-down.svg'

export default {
  name: 'HotspotArtHtml',
  props: {
    hotspot: {
      type: Object,
      required: false
    },
    exit: {
      type: Boolean
    }
  },

  methods: {
    isIcon (type) {
      return this.hotspot.position.indexOf(type) > -1
    },
    onClick () {
      this.$emit('onClick', this.hotspot)
    }
  },

  data () {
    return {
      isHidden: false
    }
  },
  mounted () {
    this.$events.on('onCloseHotspot', () => {
      this.isHidden = false
    })

    this.$events.on('onOpenHotspot', (hotspot) => {
      this.isHidden = true
    })
  },

  components: {
    HotspotPulse,
    IconArrowRight,
    IconArrowLeft,
    IconArrowUp,
    IconArrowDown,
    IconPov,
    IconClose,
    IconOpen,
    IconExit
  }
}
</script>

<style lang="scss" scoped>
.block {
  width: 75px;
  height: 75px;
  border-radius: 75px;
  background-color: $c-light-pink;
}

.block-circle {
  background-color: $c-white !important;
}

.circle {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: $c-light-pink;
}

.circle-outline {
  .dot {
    width: 30px;
    height: 30px;
    border-radius: 20px;
    background-color: $c-light-pink;
    transition: transform 0.5s;
    z-index: 0;
  }

  &::before {
    content: '';
    width: 60px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid $c-light-pink;
    border-radius: 30px;
  }

  svg {
    width: 12px;
    height: 12px;
    z-index: 1;
    transition: transform 0.5s;

    path {
      fill: $c-black;
      // stroke-width: 1px;
    }
  }
}

.icon {
  fill: $c-light-pink;
  width: 40px;
  height: 40px;
}

span {
  color: $c-light-pink;
  line-height: 12px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 100;
  text-align: center;
}

.hotspot-container {
  position: relative;
  transition: opacity 0.5s;
  cursor: pointer;
  pointer-events: all;

  &:hover {
    .rollover-info {
      opacity: 1;
    }

    ::v-deep .pulse {
      opacity: 0;
    }

    svg,
    .dot {
      transform: translate(-50%, -50%) scale(2);
    }
  }
}

.rollover-info {
  transform: translate(-50%, calc(-100% - 70px));
  background-color: $c-light-pink;
  width: 200px;
  opacity: 0;
  pointer-events: none;

  p {
    text-align: center;
  }
}
</style>
